import { RiskFactorStats } from "~/operations";
import { Chip } from "../vulnerabilities/chip";
import {
  getRiskFactorColors,
  getRiskFactorIcon,
} from "~/pages/space/security/components/RiskFactors/utils";
import { useTheme } from "@mui/material";
import { useColorMode } from "~/providers/color-mode";

export type RiskFActorsChipProps = {
  riskFactor: Pick<
    RiskFactorStats,
    "indicator" | "title" | "isPositive" | "affected"
  >;
};

export function RiskFactorsChip({ riskFactor }: RiskFActorsChipProps) {
  const theme = useTheme();
  const { mode } = useColorMode();
  const icon = getRiskFactorIcon({ indicator: riskFactor.indicator });
  const { textColor, fillColor } = getRiskFactorColors({
    theme,
    light: mode === "light",
    isPositive: riskFactor.isPositive,
    isAffected: riskFactor.affected > 0,
  });
  const label = riskFactor.title;

  return (
    <Chip
      label={label}
      variant="filled"
      icon={icon}
      sx={{
        textTransform: label === "eol" ? "uppercase" : "capitalize",
        backgroundColor: fillColor,
        color: textColor,
        ".MuiChip-icon": {
          color: textColor,
        },
      }}
    />
  );
}
